
import React from "react";

export const Footer = (props) => {
  const CurrentYear = () => {
    const date = new Date().getFullYear();
    return <>{date}</>;
  };

  return (
    <div>
      <div id="follow">
        <div className="container">
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <h3>Síguenos</h3>
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"} target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-brands fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.tiktok : "/"} target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-brands fa-tiktok"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          &copy; <CurrentYear /> Practiabogados
        </div>
      </div>
    </div>
  );
};
